/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { InventoryPromoLink, type InventoryPromoLinkProps } from 'sarsaparilla';

import * as MapHelper from 'shared-ui/maps/helpers/mapHelper';

const propTypes = {
    searchResult: PropTypes.shape({
        name: PropTypes.string,
        state_code: PropTypes.string,
        city: PropTypes.string,
        number_of_ratings: PropTypes.number,
        average_rating: PropTypes.number,
        preview_image_url: PropTypes.string,
        campsite_equipment_name: PropTypes.array,
        availability: PropTypes.string,
        campsite_type_of_use: PropTypes.array,
    }),
};

interface CampingDayUseItemProps extends Omit<
    InventoryPromoLinkProps,
    'href' | 'heading'
> {
    searchResult: {
        name: string;
        state_code: string;
        city: string;
        number_of_ratings: number;
        average_rating: number;
        preview_image_url: string;
        campsite_equipment_name: any[];
        availability:
            | 'available'
            | 'partially available'
            | 'not reservable'
            | 'lottery'
            | 'CAMPING_LOTTERY'
            | 'unavailable'
            | 'new'
            | 'enter dates'
            | 'enter date'
            | 'view availability'
            | undefined;
        campsite_type_of_use: any[];
    };
}

export default function CampingDayUseItem({
    searchResult,
    ...rest
}: CampingDayUseItemProps) {
    const inventoryTags = searchResult.campsite_type_of_use?.map((use) => {
        switch (use) {
            case 'Day':
                return 'DayUse';
            case 'Overnight':
                return 'Camping';
            default:
                return '';
        }
    });
    const copy = searchResult.campsite_equipment_name?.join(', ');
    let location = searchResult.state_code;
    if (searchResult.city) {
        location = `${searchResult.city}, ${location}`;
    }
    const tags = inventoryTags?.filter((item) => item !== '');

    return (
        <InventoryPromoLink
            inventoryTags={tags}
            location={location}
            hasStarRating={searchResult.number_of_ratings > 0}
            href={MapHelper.getTargetUri(searchResult)}
            reviewCount={searchResult.number_of_ratings}
            rating={searchResult.average_rating}
            availabilityTag={searchResult.availability}
            imagePath={searchResult.preview_image_url}
            heading={searchResult.name}
            maxHeadingLength={53}
            {...rest}
        >
            <div className="equipment-list">{copy}</div>
        </InventoryPromoLink>
    );
}

CampingDayUseItem.propTypes = propTypes;
